import { createBrowserHistory } from "history";
import queryString from "query-string";

const { lang = "en", id, activate } = queryString.parse(
  window.location.search
);

const history = createBrowserHistory()
const apiUrl = process.env.REACT_APP_API_URL;
const stylesUrl = process.env.REACT_APP_STYLES;

const currentLang = lang === "ar" ? "ar" : "en";

export const settings = {
  lang: currentLang,
  history,
  apiUrl,
  listing: id,
  stylesUrl,
  activate
}

// Drops `activate` from the address bar once activation has been dealt with,
// so refreshing the page does not run it again. The backend sends a mail on
// every activate call, so re-running it spams the subscriber.
//
// This rewrites the URL directly instead of going through `history`, to avoid
// pushing a navigation the router would have to re-render for. `settings.activate`
// is deliberately left alone: the current page load should still show the
// confirmation banner, it is only the next load that must not re-activate.
export const clearActivateParam = () => {
  const params = queryString.parse(window.location.search);
  if (params.activate === undefined) return;

  delete params.activate;
  const search = queryString.stringify(params);
  window.history.replaceState(
    {},
    "",
    `${window.location.pathname}${search ? `?${search}` : ""}`
  );
};
